import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  Stack,
  Grid,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";

import SimilarProducts from "../Home/NewDesign/Products/SimilarProduct";
import FrequentlyBoughtTogether from "../Home/NewDesign/Products/FrequentlyBoughtTogether";
import { actSendProductsRequest } from "../../actions";
import { BASE_URL_MEDIA } from "../../Redux/App/action";
import {
  createOrder,
  getSingleProduct,
  getNotifyMe,
} from "../../Redux/ProductController/action";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CheckLocationModal from "../UI/CheckLocationModal";
// import Wishlist from "../UI/WishlistHeart";

const Products = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();
  const params = useParams();
  const productId = +params._id;
  const myState = useSelector((state) => state.ProductCart);
  const { singleproduct, orderList } = useSelector(
    (store) => store.prodReducer
  );

  const token = localStorage.getItem("token");
  const [selectedVariantIndex, setSelectedVariantIndex] = useState();
  const [ImageUrls, setImageUrls] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [openVariantIndex, setOpenVariantIndex] = useState(0);
  const [path, setPath] = useState("");
  const [singleProductQuantity, setSingleProductQuantity] = useState(1);

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  useEffect(() => {
    dispatch(getSingleProduct(productId));
  }, [dispatch, productId]);

  const handleVariantClick = (index, variantId) => {
    if (openVariantIndex === index) {
      setOpenVariantIndex(null);
      setSelectedVariantIndex(singleproduct.variants[0]?.id);
    } else {
      setOpenVariantIndex(index);
      setSelectedVariantIndex(variantId);
    }
  };

  const handleAddToCart = async () => {
    // const btnText = event.currentTarget.textContent;

    if (token == null) {
      navigate("/authenticate", {
        state: { referrer: `/productDetails/${productId}` },
      });
      toast({
        title: "Please Login First",
        status: "success",
        duration: 5000,
        position: "top",
        isClosable: true,
      });
    } else {
      const cartData = {
        productId: productId,
        variantId: singleproduct.variants[0].id,
        quantity: singleProductQuantity,
      };

      if (myState.error) {
        // Display error message if there's an error
        toast({
          title: "Please try after some time",
          status: "error",
          duration: 5000,
          position: "top",
          isClosable: true,
        });
        return;
      }

      // No error, proceed with the logic
      // setPath("/Cart/AddToCart");

      // If the button text is "Go to Cart," set path again and return
      // if (btnText === "Go to Cart") {
      //   setPath("/Cart/AddToCart");
      //   return;
      // }

      // Dispatch actions if no error and the button text is not "Go to Cart"
      await dispatch(actSendProductsRequest(cartData));

      navigate("/Cart/AddToCart");
    }
  };

  useEffect(() => {
    if (myState.error === true) {
      setPath("/Cart/AddToCart");
    }
  }, [myState.error]);

  useEffect(() => {
    if (singleproduct.variants && singleproduct.variants.length > 0) {
      setSelectedVariantIndex(singleproduct.variants[0].variantId);
    }
  }, [singleproduct]);

  const handleQuantityIncrease = () => {
    setSingleProductQuantity((prev) => prev + 1);
  };

  const handleQuantityDecrease = () => {
    setSingleProductQuantity(singleProductQuantity - 1);
  };

  useEffect(() => {
    dispatch(getSingleProduct(productId));
  }, [dispatch, productId]);

  const handleProceedToBuyNow = () => {
    if (token == null) {
      navigate("/authenticate", {
        state: { referrer: `/productDetails/${productId}` },
      });
      toast({
        title: "Please Login First",
        status: "success",
        duration: 5000,
        position: "top",
        isClosable: true,
      });
    } else {
      const orderData = {
        productId: productId,
        variantId: selectedVariantIndex,
        quantity: myState.quantity,
        orderType: "BUY_NOW",
      };
      dispatch(createOrder(orderData));
      if (orderList?.find((item) => item.productId === productId)) {
        orderList?.push(orderData);
      } else if (orderList?.find((item) => item?.productId === productId)) {
        const indexToRemove = orderList.findIndex(
          (obj) => obj?.productId === productId
        );
        if (indexToRemove !== -1) {
          orderList?.splice(indexToRemove, 1);
          orderList?.push(orderData);
        }
      }
      navigate("/Cart/PlaceOrder");
    }
  };

  const getImages = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/media/file/admin/get/productfiles?sourceMediaId=${singleproduct?.variants?.[0]?.sourceMediaId}`
      );
      if (response && response?.status === 200) {
        setImageUrls(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [singleproduct.variants]);

  useEffect(() => {
    getImages();
  }, [getImages]);

  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const [isReadMoreHighlight, setIsReadMoreHighlight] = useState(true);
  const toggleReadMoreHighlight = () => {
    setIsReadMoreHighlight(!isReadMoreHighlight);
  };

  const [showModal, setShowModal] = useState("hidden");

  const pinCodeHandler = () => {
    setShowModal("hidden");
  };

  const notifyMeHandler = (productId) => {
    toast({
      title: "We will notify you, when the product is available",
      status: "success",
      duration: 3000,
      position: "top",
      isClosable: true,
    });
    dispatch(getNotifyMe(productId));
  };

  return (
    <div className="md:p-4">
      <CheckLocationModal
        display={showModal}
        hidePinCodeModal={pinCodeHandler}
      />
      {singleproduct && singleproduct.length !== 0 ? (
        <Box>
          <Box textAlign={{ base: "center", md: "left" }}>
            <Text
              color={"#3C375F"}
              fontFamily="Oswald, sans-serif"
              fontSize={{ base: "20", md: "28" }}
              fontWeight={"Bold"}
            >
              Shop{" "}
              {singleproduct?.length !== 0 &&
                `${
                  singleproduct?.productCategory[0]
                }${singleproduct?.productCategory.substring(1).toLowerCase()}`}
            </Text>
            <Text
              mt={{ base: "0", md: "0", lg: "-2" }}
              fontSize={{ base: "10", md: "20", lg: "20" }}
              color={"#3C375F"}
              fontFamily={"Lato, sans-serif"}
              fontWeight={"normal"}
            >
              For Your Loved one’s
            </Text>
          </Box>

          <Box mt={{ md: "5" }}>
            <Flex
              flexDirection={{ base: "column", md: "row" }}
              alignItems={{ base: "center", md: "flex-start" }}
              justifyContent={"space-between"}
              padding={"0 0.5em"}
            >
              {/*Product Images*/}
              <Box
                display="flex"
                flexDirection={{ base: "row" }}
                gap={1}
                mb={{ base: "1em" }}
              >
                <Box display="flex" flexDirection="column" alignItems="center">
                  {/* overflowY={{ base: "auto", md: "auto" }} */}
                  <Flex
                    justifyContent="space-between"
                    flexDirection={{
                      base: "column",
                      md: "column",
                      lg: "column",
                    }}
                  >
                    {ImageUrls?.slice(0, 4).map((image, i) => (
                      <Image
                        key={i}
                        src={image.imageUrl}
                        alt={`variant-image`}
                        borderRadius="2"
                        w={20}
                        h={20}
                        cursor="pointer"
                        transition="boxSize 0.3s ease-in-out"
                        marginRight="10px"
                        marginBottom={"10px"}
                        _hover={{ border: "2px", borderColor: "#2874f0" }}
                        onMouseEnter={() => handleImageClick(i)}
                      />
                    ))}
                  </Flex>
                </Box>

                <Box>
                  <Stack position="relative" spacing={0}>
                    <Image
                      src={
                        ImageUrls[selectedImageIndex]?.imageUrl ||
                        singleproduct.img
                      }
                      alt="bg"
                      w={300}
                      h={350}
                      borderRadius={"10"}
                    />
                    {/* <Wishlist
                      sourceMediaId={singleproduct?.variants[0]?.sourceMediaId}
                      productId={singleproduct?.variants[0]?.productId}
                      variantId={singleproduct?.variants[0]?.id}
                    /> */}
                  </Stack>
                </Box>
              </Box>

              {/*Product Details*/}
              <Box
                textAlign={{ base: "left", md: "left", lg: "left" }}
                alignItems={"center"}
                w={{ base: "100%", md: "45%" }}
              >
                <Box>
                  <Box
                    display={"flex"}
                    py={"2"}
                    flexDirection={{ base: "row", md: "row", lg: "row" }}
                    justifyContent={"space-between"}
                  >
                    <Text
                      p={2}
                      borderRadius={"4"}
                      color={"white"}
                      bgColor={"#14D2B8"}
                      fontFamily={"Oswald, bold"}
                    >
                      Lowest Price In 30 Days
                    </Text>
                  </Box>
                  <Text
                    color={"#3C375F"}
                    fontFamily="Oswald, sans-serif"
                    fontWeight={"bold"}
                    fontSize={{ base: "20", md: "28", lg: "28" }}
                    mb={{ base: "2" }}
                    mt={{ base: "0", lg: "-2" }}
                  >
                    {singleproduct.productName}
                  </Text>
                  <Flex flexDirection={{ base: "row", md: "row", lg: "row" }}>
                    <Box>
                      <Image
                        h={{ base: "70%", md: "80%", lg: "70%" }}
                        w={{ base: "70%", md: "50%", lg: "65%" }}
                        src="https://i.ibb.co/3NGXqkM/4stars.png"
                        alt="4stars"
                        border="0"
                        mb={{ base: "2" }}
                      ></Image>
                    </Box>
                    <Box>
                      <Text
                        h={{ base: "100%", md: "80%", lg: "80%" }}
                        w={{ base: "100%", md: "100%", lg: "100%" }}
                      >
                        54 Reviews
                      </Text>
                    </Box>
                  </Flex>

                  <Box>
                    <Flex gap={"5px"}>
                      <Text
                        as="span"
                        textDecoration="line-through"
                        color="gray"
                        fontSize={"18px"}
                      >
                        ₹
                        {singleproduct.variants &&
                          singleproduct.variants.length > 0 &&
                          (openVariantIndex !== null
                            ? singleproduct.variants[openVariantIndex]
                                ?.priceDetails.price
                            : singleproduct.variants[0]?.priceDetails.price)}
                      </Text>

                      <Flex gap={"10px"}>
                        <Text fontSize={"18px"} fontWeight="bold">
                          ₹
                          {singleproduct.variants &&
                            singleproduct.variants.length > 0 &&
                            (openVariantIndex !== null
                              ? singleproduct.variants[openVariantIndex]
                                  ?.priceDetails.sellingPrice
                              : singleproduct.variants[0]?.priceDetails
                                  .sellingPrice)}
                        </Text>
                        <Text
                          bg="#1E9C99"
                          w={"90px"}
                          height={"30px"}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          rounded="md"
                          fontSize={{ base: "14px", sm: "16px" }}
                          fontWeight="bold"
                          color={"white"}
                        >
                          {singleproduct.variants &&
                            singleproduct.variants.length > 0 &&
                            (openVariantIndex !== null
                              ? `(${singleproduct.variants[openVariantIndex]?.priceDetails.discountPercentage}% Off)`
                              : `(${singleproduct.variants[0]?.priceDetails.discountPercentage} % Off)`)}
                        </Text>
                      </Flex>
                    </Flex>
                  </Box>

                  <Box
                    mt={{ base: "1", md: "0", lg: "1" }}
                    fontSize={{ base: "14", md: "14" }}
                  >
                    {isReadMore && singleproduct.productDescription
                      ? singleproduct.productDescription.slice(0, 100)
                      : singleproduct.productDescription}
                    <span
                      onClick={toggleReadMore}
                      style={{ color: "green", cursor: "pointer" }}
                    >
                      {isReadMore ? "...read more" : "...show less"}
                    </span>
                  </Box>

                  <Box mb={"2"}>
                    <Box>
                      <Text
                        fontSize={"16px"}
                        color={"#06211A"}
                        fontFamily={"Lato, sans-serif"}
                        fontWeight={"semibold"}
                        mt={{ base: "5", md: "0", lg: "5" }}
                      >
                        Variants
                      </Text>
                      <Flex
                        flexDirection={{ base: "column", md: "row", lg: "row" }}
                        alignItems="flex-start"
                        mt={{ base: "2", md: "0", lg: "2" }}
                        style={{ overflowWrap: "break-word" }}
                        flexWrap="wrap"
                      >
                        <Grid
                          templateColumns={{
                            base: "1fr",
                            md: "repeat(2, 1fr)",
                          }}
                        >
                          {singleproduct.variants?.map((product, i) => (
                            <Box
                              key={i}
                              mb={{ base: "2", md: "0" }}
                              mr={{ base: "0", md: "2" }}
                            >
                              <Button
                                variant="solid"
                                size="sm"
                                onClick={() => {
                                  handleVariantClick(i, product.id);
                                  setSelectedVariantIndex(product.id);
                                }}
                                color={"black"}
                                bgColor={"#36BAD5"}
                              >
                                {product.variantName}
                              </Button>
                            </Box>
                          ))}
                        </Grid>
                      </Flex>
                    </Box>
                  </Box>

                  <Box>
                    {singleproduct.variants?.map((product, i) => {
                      return (
                        <Box
                          key={i}
                          display={openVariantIndex === i ? "block" : "none"}
                          mt="2"
                        >
                          <Text
                            fontWeight={"bold"}
                            fontSize={{ base: "16", md: "16" }}
                          >
                            Highlights:
                          </Text>
                          <Text fontSize={{ base: "16", md: "14" }}>
                            {isReadMoreHighlight && product.variantDescription
                              ? product.variantDescription.slice(0, 100)
                              : product.variantDescription}
                            <span
                              onClick={toggleReadMoreHighlight}
                              style={{ color: "green", cursor: "pointer" }}
                            >
                              {isReadMoreHighlight
                                ? "...read more"
                                : "...show less"}
                            </span>
                          </Text>
                          <Text>
                            <Text fontSize={{ base: "16", md: "14" }}>
                              {singleproduct.productCategory === "PLANTS" ? (
                                <></>
                              ) : (
                                <>
                                  {" "}
                                  <strong>Color:</strong> {product.color}
                                </>
                              )}
                            </Text>
                            <Text fontSize={{ base: "16", md: "14" }}>
                              {" "}
                              {product.description}
                            </Text>
                            {/* <Text fontSize={{ base: "16", md: "14" }}>
                          <strong>Price:</strong> {product.price}
                        </Text> */}
                            <Text fontSize={{ base: "16", md: "14" }}>
                              {singleproduct.productCategory === "PLANTS" ? (
                                <>
                                  {" "}
                                  <strong>Dimension :</strong>{" "}
                                  <span>{product.dimension}</span>{" "}
                                </>
                              ) : (
                                <>
                                  {" "}
                                  <strong>Weight:</strong>{" "}
                                  <span>{product.weight}</span>
                                </>
                              )}
                            </Text>
                            <Text fontSize={{ base: "16", md: "14" }}>
                              <strong>
                                {singleproduct.productCategory === "PLANTS"
                                  ? "Category:"
                                  : ""}
                              </strong>{" "}
                              {singleproduct.productSubCategory}
                            </Text>
                            <Text fontSize={{ base: "16", md: "14" }}>
                              <strong>
                                {singleproduct.productCategory === "PLANTS"
                                  ? "Watering:"
                                  : "Material Type:"}
                              </strong>{" "}
                              {product.materialType}
                            </Text>
                          </Text>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </Box>

              {/*Delivery Detail*/}
              <Box
                px={"2"}
                py={2}
                margin={"1em 0"}
                w={{ md: "250px" }}
                background="#FFFFFF"
                boxShadow="2px 5px 10px rgba(0, 0, 0, 0.29)"
                borderRadius="10px"
                opacity="1"
              >
                <Box
                  cursor={"pointer"}
                  onClick={() => {
                    setShowModal("block");
                  }}
                >
                  <Flex alignItems={"center"} padding={"1em 0"}>
                    <Image
                      ml={"3.5"}
                      h={"20px"}
                      w={"19px"}
                      src="https://i.ibb.co/b5LBFy8/location-icon-184057-2.png"
                      alt="location-icon-184057-2"
                      border="0"
                    />
                    <Text fontFamily="Lato, sans-serif" color="#2A7CC3">
                      Check delivery location
                    </Text>
                  </Flex>
                </Box>
                <hr className="p-1" />
                <Box>
                  <Flex
                    flexDirection={{
                      base: "row",
                      md: "row",
                    }}
                    justifyContent={"space-between"}
                  >
                    <Text
                      ml={"4"}
                      mt={"4"}
                      fontWeight={"bold"}
                      fontSize={{ base: "16", md: "12" }}
                    >
                      Quantity
                    </Text>
                    <Box
                      ml={{ base: "32", md: "4", lg: "4" }}
                      mt={{ base: "3", md: "3" }}
                      borderRadius={"8"}
                    >
                      <Box>
                        <div className="flex justify-center items-center">
                          <Button
                            className="bg-[#36BAD5]"
                            borderRadius="10px 0px 0px 10px"
                            opacity="1"
                            onClick={() => handleQuantityDecrease()}
                            size="xs"
                            variant="outline"
                            isDisabled={singleProductQuantity < 2}
                          >
                            -
                          </Button>
                          <Box h={"8"}>
                            <Text mx="2">{singleProductQuantity}</Text>
                          </Box>
                          <Button
                            background="#36BAD5"
                            borderRadius="0px 10px 10px 0px"
                            opacity="1"
                            onClick={() => handleQuantityIncrease()}
                            size="xs"
                            variant="outline"
                            isDisabled={singleProductQuantity > 4}
                          >
                            +
                          </Button>
                        </div>
                      </Box>
                    </Box>
                  </Flex>

                  {singleproduct.isAllVariantSoldOut ? (
                    <Button
                      onClick={() => {
                        notifyMeHandler(singleproduct?.productId);
                      }}
                      mt={"10px"}
                      bg="#F52E7D"
                      fontSize={"13px"}
                      width={"100px"}
                      height={"35px"}
                      color={"white"}
                    >
                      Notify Me
                    </Button>
                  ) : (
                    <Box
                      margin={"auto"}
                      display={"flex"}
                      mt={{ base: "5" }}
                      flexDirection={{ base: "column", md: "row" }}
                      // justifyContent={"space-evenly"}
                      w={{ base: "100%", md: "100%" }}
                    >
                      <Box
                        display={"flex"}
                        w={{ base: "100%" }}
                        mt={{ base: "5" }}
                        flexDirection={{ base: "column", md: "row" }}
                        justifyContent={"space-evenly"}
                        gap={2}
                      >
                        <Button
                          px={"2"}
                          py={"2"}
                          w={"100%"}
                          borderRadius="10px"
                          background="#E4DEDE"
                          opacity="1"
                          fontFamily="Oswald, sans-serif"
                          fontSize={{ base: "14" }}
                          fontWeight="bold"
                          textTransform="uppercase"
                          color="#3C375F"
                          _hover={{
                            background: "#D1CFCF",
                            boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.1)",
                          }}
                          onClick={() => {
                            handleAddToCart();
                          }}
                        >
                          {/* {path ? (
                            <Link to={path}>
                              <Text>{"Go to Cart"}</Text>
                            </Link>
                          ) : (
                            <Text>{"Add to Cart"}</Text>
                          )} */}
                          Add to Cart
                        </Button>
                        {/* <Button
                          px={"5"}
                          py={"2"}
                          my={{ base: "5", md: "0" }}
                          background="#FC1A64"
                          opacity="1"
                          fontFamily="Oswald, sans-serif"
                          fontSize={{ base: "14" }}
                          fontWeight="bold"
                          letterSpacing="0"
                          textTransform="uppercase"
                          color="white"
                          borderRadius="10px"
                          _hover={{
                            background: "#F52E7D",
                            boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.1)",
                          }}
                          onClick={handleProceedToBuyNow}
                        >
                          Buy Now
                        </Button> */}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            </Flex>
          </Box>

          <Box mt={{ base: "5", lg: 0 }}>
            {/* FREQUENTLY BOUGHT TOGETHER*/}
            <Box
              textAlign={"left"}
              margin={{ base: "auto" }}
              w={{ base: "90%", md: "100%", lg: "100%" }}
            >
              <FrequentlyBoughtTogether />
            </Box>

            {/*SIMILAR PRODUCTS*/}
            <Box
              mt={5}
              textAlign={"left"}
              mb={"17"}
              margin={{ base: "auto" }}
              w={{ base: "90%", md: "100%", lg: "100%" }}
            >
              <SimilarProducts pid={productId} />
            </Box>
          </Box>
        </Box>
      ) : (
        <Text>Product not found.</Text>
      )}
    </div>
  );
};

export default Products;
